import { getStringFromObject } from '../constants/lodashUtils';
import { isArrayValidAndNotEmpty } from '../constants/CommonUtil';
import { validateExactlyOneCostAttribution } from './costAttributionValidationUtils';

const COST_ATTRIBUTION_COLUMN_NAMES = ['costCenter', 'distributionPlan', 'skipCostAttribution'];

const COST_ACCOUNT_SUGGEST_API = [
    '/nuacare-core/rest/nuacare/v1/erp-service/analyticalAccount/suggestAccounts',
    '?type=COST_ACCOUNT&searchString=',
].join('');

const DISTRIBUTION_PLAN_SUGGEST_API = [
    '/nuacare-core/rest/nuacare/v1/erp-service/costAccounting/distributionPlans/suggest',
    '?searchString=',
].join('');

export const EXPENSE_COST_ACCOUNTING_TABLE_CELLS = [
    {
        label: 'Cost Acct',
        noLabel: true,
        fullWidth: true,
        fieldType: 'autosuggest',
        id: 'costCenter',
        name: 'costCenter',
        disableIfList: [
            { name: 'skipCostAttribution', value: true },
        ],
        callType: 'GET',
        dataSourceApi: COST_ACCOUNT_SUGGEST_API,
        onSelectHandlers: ['onAccountSelect'],
        dataSourceConfig: {
            text: 'value',
            value: 'key',
        },
        headerStyle: {
            minWidth: 140,
            width: 140,
            fontSize: '12px',
            whiteSpace: 'normal',
            lineHeight: 1.2,
        },
        cellStyle: {
            minWidth: 140,
            maxWidth: 180,
        },
    },
    {
        label: 'Dist. Plan',
        noLabel: true,
        fullWidth: true,
        fieldType: 'autosuggest',
        id: 'distributionPlan',
        name: 'distributionPlan',
        disableIfList: [
            { name: 'skipCostAttribution', value: true },
        ],
        callType: 'GET',
        dataSourceApi: DISTRIBUTION_PLAN_SUGGEST_API,
        onSelectHandlers: ['onAccountSelect'],
        dataSourceConfig: {
            text: 'value',
            value: 'key',
        },
        headerStyle: {
            minWidth: 140,
            width: 140,
            fontSize: '12px',
            whiteSpace: 'normal',
            lineHeight: 1.2,
        },
        cellStyle: {
            minWidth: 140,
            maxWidth: 180,
        },
    },
    {
        label: 'Skip',
        noLabel: true,
        fieldType: 'checkbox',
        id: 'skipCostAttribution',
        name: 'skipCostAttribution',
        onChangeHandlers: ['onSkipCostAttributionChange'],
        disableIfList: [
            { name: 'costCenter.key', hasValue: true },
            { name: 'distributionPlan.key', hasValue: true },
        ],
        headerStyle: {
            minWidth: 52,
            width: 52,
            fontSize: '12px',
            textAlign: 'center',
        },
        cellStyle: {
            minWidth: 52,
            width: 52,
            textAlign: 'center',
        },
    },
];

const mergeCostAccountingTableCell = (cell) => {
    const compactCell = EXPENSE_COST_ACCOUNTING_TABLE_CELLS.find(
        costCell => costCell.name === cell.name,
    );
    if (!compactCell) {
        return cell;
    }
    return {
        ...cell,
        ...compactCell,
        dataSourceConfig: {
            ...getStringFromObject('dataSourceConfig', cell, {}),
            ...compactCell.dataSourceConfig,
        },
    };
};

export const applyExpenseCostAccountingTableCells = (tableCells, costAccountingEnabled) => {
    if (!isArrayValidAndNotEmpty(tableCells)) {
        return tableCells;
    }
    const withoutCostCells = tableCells.filter(cell => !COST_ATTRIBUTION_COLUMN_NAMES.includes(cell.name));
    if (!costAccountingEnabled) {
        return withoutCostCells;
    }
    if (tableCells.some(cell => COST_ATTRIBUTION_COLUMN_NAMES.includes(cell.name))) {
        return tableCells.map(mergeCostAccountingTableCell);
    }
    const categoryIndex = withoutCostCells.findIndex(cell => cell.name === 'category');
    if (categoryIndex >= 0) {
        return [
            ...withoutCostCells.slice(0, categoryIndex + 1),
            ...EXPENSE_COST_ACCOUNTING_TABLE_CELLS,
            ...withoutCostCells.slice(categoryIndex + 1),
        ];
    }
    return [...withoutCostCells, ...EXPENSE_COST_ACCOUNTING_TABLE_CELLS];
};

export const buildExpenseFormSchema = (schema, costAccountingEnabled) => {
    if (!schema) {
        return schema;
    }
    return {
        ...schema,
        tableCells: applyExpenseCostAccountingTableCells(
            getStringFromObject('tableCells', schema, []),
            costAccountingEnabled,
        ),
    };
};

const validateExpenseLineCostAttribution = (line, index) => {
    const categoryKey = getStringFromObject('category.key', line);
    if (!categoryKey) {
        return null;
    }
    const lineLabel = `Expense ${getStringFromObject('description', line) || `line ${index + 1}`}`;
    return validateExactlyOneCostAttribution(line, lineLabel);
};

export const validateExpenseLinesCostAttribution = (lines, costAccountingEnabled) => {
    if (!costAccountingEnabled || !isArrayValidAndNotEmpty(lines)) {
        return null;
    }
    for (let i = 0; i < lines.length; i += 1) {
        const validationError = validateExpenseLineCostAttribution(lines[i], i);
        if (validationError) {
            return validationError;
        }
    }
    return null;
};

export default validateExpenseLinesCostAttribution;
